var MethodPassMode = (function () {
    function MethodPassMode() {
    }
    return MethodPassMode;
}());
export { MethodPassMode };
/**
 *
 */
MethodPassMode.EFFECTS = 0x01;
/**
 *
 */
MethodPassMode.LIGHTING = 0x02;
/**
 *
 */
MethodPassMode.SUPER_SHADER = 0x03;



// WEBPACK FOOTER //
// ../dist/lib/surfaces/passes/MethodPassMode.js